/** URL publique du site (sans slash final). Définir VITE_SITE_URL dans le .env racine. */
export function getSiteUrl() {
  const u = import.meta.env.VITE_SITE_URL;
  if (u && typeof u === "string") return u.replace(/\/$/, "");
  return "https://raguia.valentin-fiess.fr";
}

export function getOgImageUrl() {
  const custom = import.meta.env.VITE_OG_IMAGE;
  if (custom && String(custom).startsWith("http")) return custom;
  return `${getSiteUrl()}/raguia.webp`;
}

export function buildOrganizationJsonLd() {
  const url = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Raguia",
    url,
    logo: `${url}/raguia.webp`,
    description:
      "Raguia — assistant documentaire IA B2B : chatbot RAG, portail client, hébergement en France.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "FR",
    },
    sameAs: ["https://valentin-fiess.fr"],
  };
}

export function buildSoftwareJsonLd() {
  const url = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Raguia",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    offers: {
      "@type": "Offer",
      priceCurrency: "EUR",
      availability: "https://schema.org/InStock",
    },
    url,
    description:
      "Solution SaaS d’assistant IA sur vos documents : RAG, OCR, portail client, isolation par entreprise.",
  };
}

export function buildWebSiteJsonLd() {
  const url = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Raguia",
    url,
    inLanguage: "fr-FR",
    publisher: { "@type": "Organization", name: "Raguia", url },
  };
}

export function buildFAQPageJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

export function buildBreadcrumbListJsonLd(items) {
  const url = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      ...(item.path != null ? { item: `${url}${item.path}` } : {}),
    })),
  };
}

export function buildSiteNavigationElementJsonLd() {
  const url = getSiteUrl();
  return [
    { name: "Accueil", path: "/" },
    { name: "Tarifs", path: "/tarifs" },
    { name: "Contact", path: "/contact" },
  ].map((item) => ({
    "@context": "https://schema.org",
    "@type": "SiteNavigationElement",
    name: item.name,
    url: `${url}${item.path}`,
  }));
}
